import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
const win: any = window
let lng: any = win['lang'];
i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng,
    debug: false,
    keySeparator: ".",
    returnObjects: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: window.location.href.includes("localhost") ? "/translations/{{lng}}.json" : "/.complaints-search-portal4/react-app/build/translations/{{lng}}.json",
      allowMultiLoading: true,
    },
    react: {
      wait: true,
      useSuspense: true,
    },
  });
localStorage.setItem('lng', lng)
export default i18n;
